import service from "@/store/services/document-service";

const state = {
  list: {},
  document: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, document) => {
    state.document = document;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  get({ commit, dispatch }, params) {
    return service.get(params).then(document => {
      commit("SET_RESOURCE", document);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params).then(document => {
      commit("SET_RESOURCE", document);
    });
  },

  addFree({ commit, dispatch }, params) {
    return service.addFree(params).then(document => {
      commit("SET_RESOURCE", document);
    });
  },
};

const getters = {
  list: state => state.list,
  document: state => state.document,
  get: state => state.document,
  add: state => state.document,
  addFree: state => state.document,
  dropdown: state => {
    return state.list.map(document => ({
      id: document.id,
      nombre: document.nombre,
      abreviatura: document.abreviatura
    }));
  }
};

const documentes = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default documentes;
